<template>
  <svg
    class="shape-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
  >
    <template v-if="settings.shapeMode === 'number'">
      <circle
        v-if="settings.numberStyle === 'circle'"
        cx="12"
        cy="12"
        r="10"
        :fill="filled ? activeColor : 'none'"
        :stroke="activeColor"
        stroke-width="1.5"
      />
      <rect
        v-else-if="settings.numberStyle === 'square'"
        x="2"
        y="2"
        width="20"
        height="20"
        rx="0"
        :fill="filled ? activeColor : 'none'"
        :stroke="activeColor"
        stroke-width="1.5"
      />
      <rect
        v-else-if="settings.numberStyle === 'rounded'"
        x="2"
        y="2"
        width="20"
        height="20"
        rx="5"
        :fill="filled ? activeColor : 'none'"
        :stroke="activeColor"
        stroke-width="1.5"
      />
      <text
        x="12"
        y="16.5"
        text-anchor="middle"
        font-size="13"
        font-weight="bold"
        font-family="monospace"
        :fill="
          settings.numberStyle === 'plain'
            ? activeColor
            : filled
            ? '#fff'
            : activeColor
        "
      >
        {{ value }}
      </text>
    </template>

    <template v-else>
      <path v-if="tag === 'path'" :d="shapeData.d" v-bind="attrs" />

      <circle
        v-else-if="tag === 'circle'"
        cx="12"
        cy="12"
        r="8"
        v-bind="attrs"
      />
      <rect
        v-else-if="tag === 'rect'"
        x="4"
        y="4"
        width="16"
        height="16"
        rx="2"
        v-bind="attrs"
      />
      <polygon
        v-else-if="tag === 'polygon'"
        :points="shapeData.points"
        v-bind="attrs"
      />
    </template>
  </svg>
</template>

<script>
import { SHAPES } from './ShapeModel';

export default {
  name: 'shape-icon',
  props: {
    shape: { type: String, required: true },
    color: { type: String, default: '#333' },
    value: { type: Number, default: null },
    size: { type: Number, default: 32 },
    filled: { type: Boolean, default: false },
    settings: { type: Object, required: true },
  },
  computed: {
    activeColor() {
      return this.settings.colored ? this.color : '#000';
    },
    shapeData() {
      return SHAPES[this.shape] || SHAPES.circle;
    },
    tag() {
      return this.shapeData.tag;
    },
    attrs() {
      return {
        fill: this.filled ? this.activeColor : 'none',
        stroke: this.activeColor,
        'stroke-width': this.filled ? 0 : 2,
      };
    },
  },
};
</script>

<style scoped>
.shape-icon {
  display: block;
}
</style>
